export const listDocumentHistoryService =
  (fetch) =>
  async (documentId, historyType = "institucional") => {
    try {
      const url =
        historyType === "safeCars"
          ? `/api/v2/list/documentos/vehiculos/seguros/${documentId}/historial`
          : `/api/v2/list/documentos/compania/${documentId}/historial`;

      const response = await fetch({ url });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
